var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banners"},[_c('vueper-slides',{attrs:{"autoplay":"","touchable":false}},_vm._l((_vm.slides),function(slide,i){return _c('vueper-slide',{key:i,class:("banner-" + (i + 1)),attrs:{"image":slide.image}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }